import QuoteWithTexts from './quote-with-texts';
export default QuoteWithTexts;
